import React from 'react';
import MethodologyAnchor from '../shared/methodologyAnchor/MethodologyAnchor';
import {
  StyledContainer,
  StyledTable,
  StyledValue
} from './ExperienceByRole.styled';
import { ExperienceByRoleProps } from './Talent.types';

type ExperienceByRoleTableProps = {
  data: ExperienceByRoleProps[];
};

const ExperienceByRole: React.FC<ExperienceByRoleTableProps> = ({ data }) => {
  const getClassColor = (val: number): string => {
    if (val === 0) {
      return 'cell-color-1';
    }
    if (val > 0 && val <= 5) {
      return 'cell-color-2';
    }
    if (val > 5 && val <= 9) {
      return 'cell-color-3';
    }
    if (val > 9 && val <= 14) {
      return 'cell-color-4';
    }
    if (val > 14 && val <= 19) {
      return 'cell-color-5';
    }
    if (val > 19 && val <= 24) {
      return 'cell-color-6';
    }
    if (val > 24 && val <= 29) {
      return 'cell-color-7';
    }
    if (val > 29) {
      return 'cell-color-8';
    } else {
      return 'cell-color-1';
    }
  };

  return (
    <StyledContainer>
      <StyledTable className="experience-table">
        <thead>
          <tr>
            <th></th>
            <th>&lt;2y</th>
            <th>2-5y</th>
            <th>5-10y</th>
            <th>&gt;10y</th>
          </tr>
        </thead>
        <tbody>
          {data.map((data, index) => (
            <tr key={index}>
              <th>{data.tech}</th>
              <td>
                <StyledValue className={getClassColor(data.tier1)}>
                  {data.tier1.toFixed(1)}%
                </StyledValue>
              </td>
              <td>
                <StyledValue className={getClassColor(data.tier2)}>
                  {data.tier2.toFixed(1)}%
                </StyledValue>
              </td>
              <td>
                <StyledValue className={getClassColor(data.tier3)}>
                  {data.tier3.toFixed(1)}%
                </StyledValue>
              </td>
              <td>
                <StyledValue className={getClassColor(data.tier4)}>
                  {data.tier4.toFixed(1)}%
                </StyledValue>
              </td>
            </tr>
          ))}
        </tbody>
      </StyledTable>
      <MethodologyAnchor />
    </StyledContainer>
  );
};

export default ExperienceByRole;
